module.exports = __webpack_public_path__ + "images/emoji/hourglass_flowing_sand.edffc3e23ea1a54ba602.png";